var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var CloseV3 = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.66449 5.25029C6.27396 4.85977 5.6408 4.85977 5.25028 5.25029C4.85975 5.64081 4.85975 6.27398 5.25028 6.6645L10.5858 12L5.25028 17.3355C4.85976 17.726 4.85976 18.3592 5.25028 18.7497C5.64081 19.1402 6.27397 19.1402 6.6645 18.7497L12 13.4142L17.3355 18.7497C17.726 19.1402 18.3592 19.1402 18.7497 18.7497C19.1402 18.3592 19.1402 17.726 18.7497 17.3355L13.4142 12L18.7497 6.6645C19.1402 6.27398 19.1402 5.64081 18.7497 5.25029C18.3592 4.85977 17.726 4.85977 17.3355 5.25029L12 10.5858L6.66449 5.25029Z", fill: "currentColor" }) })));
};
